import service from "@/store/services/sales-deliveries-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  salesDelivery: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, salesDelivery) => {
    state.salesDelivery = salesDelivery;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((salesDelivery) => {
      commit("SET_RESOURCE", salesDelivery);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((salesDelivery) => {
      commit("SET_RESOURCE", salesDelivery);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((salesDelivery) => {
      commit("SET_RESOURCE", salesDelivery);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  validate({ commit, dispatch }, params) {
    return service.validate(params, this.$axios).then((salesDelivery) => {
      commit("SET_RESOURCE", salesDelivery);
    });
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((salesDelivery) => {
      commit("SET_RESOURCE", salesDelivery);
    });
  },

  print({ commit, dispatch }, params) {
    return service.print(params, this.$axios);
  },

  sendMail({ commit, dispatch }, params) {
    return service.sendMail(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  salesDelivery: (state) => state.salesDelivery,
  url: (state) => state.url,
};

const salesDeliveries = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default salesDeliveries;
